import React from 'react';
// @material-ui/core components
import { makeStyles } from '@material-ui/core/styles';
import Table from '@material-ui/core/Table';
import TableRow from '@material-ui/core/TableRow';
import TableHead from '@material-ui/core/TableHead';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
// core components
import GridItem from '../../components/Admin/Grid/GridItem';
import GridContainer from '../../components/Admin/Grid/GridContainer';
// import Table from '../../components/Admin/Table/Table';
import Card from '../../components/Admin/Card/Card';
import Button from '../../components/Admin/CustomButtons/Button';
import CardHeader from '../../components/Admin/Card/CardHeader';
import CardBody from '../../components/Admin/Card/CardBody';
import useViewerInvestments from '../../providers/Customer/useViewerInvestments';
import { PreLoader } from '../../components';

import tableStyles from '../../assets/jss/material-dashboard-react/components/tableStyle';
import { nairaAmount } from '../../lib/utils';

const styles = {
  cardCategoryWhite: {
    '&,& a,& a:hover,& a:focus': {
      color: 'rgba(255,255,255,.62)',
      margin: '0',
      fontSize: '14px',
      marginTop: '0',
      marginBottom: '0',
    },
    '& a,& a:hover,& a:focus': {
      color: '#FFFFFF',
    },
  },
  cardTitleWhite: {
    color: '#FFFFFF',
    marginTop: '0px',
    minHeight: 'auto',
    fontWeight: '300',
    fontFamily: "'Roboto', 'Helvetica', 'Arial', sans-serif",
    marginBottom: '3px',
    textDecoration: 'none',
    '& small': {
      color: '#777',
      fontSize: '65%',
      fontWeight: '400',
      lineHeight: '1',
    },
  },
};

const useStyles = makeStyles((theme) => ({ ...styles, ...tableStyles(theme) }));

const tableHead = ['ID', 'Status', 'Amount', 'Accrued ROI', 'Targeted ROI', 'Start Date', 'Maturity Date'];

const statusColor = {
  pending: 'warning',
  active: 'primary',
  closed: 'info',
  'closed/ended': 'info',
  canceled: 'danger',
  liquidated: 'danger',
};

const InvestmentStatus = (status) => (
  <Button color={statusColor[status.toLowerCase()]} size="sm" disabled>
    {status}
  </Button>
);

export default function TableList() {
  const classes = useStyles();
  const { investments, loading } = useViewerInvestments();

  if (loading) return <PreLoader />;

  return (
    <GridContainer>
      <GridItem xs={12} sm={12} md={12}>
        <Card>
          <CardHeader color="primary">
            <h4 className={classes.cardTitleWhite}>All Investments</h4>
            <p className={classes.cardCategoryWhite}>Showing {investments.length} investments</p>
          </CardHeader>
          <CardBody>
            {/* <Table
              tableHeaderColor="primary"
              tableHead={['ID', 'Status', 'Amount', 'maturityDate']}
              tableData={investments.map((inv) => [inv.identifier, inv.status.name, inv.principal, inv.tenure, inv.maturityDate])}
            /> */}
            <Table className={classes.table}>
              <TableHead className={classes.primaryTableHeader}>
                <TableRow className={classes.tableHeadRow}>
                  {tableHead.map((prop, key) => (
                    <TableCell className={`${classes.tableCell} ${classes.tableHeadCell}`} key={key}>
                      {prop}
                    </TableCell>
                  ))}
                </TableRow>
              </TableHead>
              <TableBody>
                {investments.map((inv) => (
                  <TableRow key={inv.id} className={classes.tableRow}>
                    <TableCell className={classes.tableCell}>{inv.identifier}</TableCell>
                    <TableCell className={classes.tableCell}>{InvestmentStatus(inv.status.name)}</TableCell>
                    <TableCell className={classes.tableCell}>{nairaAmount(inv.principal)}</TableCell>
                    <TableCell className={classes.tableCell}>{nairaAmount(inv.accumulatedROI)}</TableCell>
                    <TableCell className={classes.tableCell}>{nairaAmount(inv.totalROI)}</TableCell>
                    <TableCell className={classes.tableCell}>{inv.investmentDate}</TableCell>
                    <TableCell className={classes.tableCell}>{inv.maturityDate}</TableCell>
                    {/* <TableCell className={classes.tableActions}>
                      <Tooltip id="tooltip-top" title="Edit Task" placement="top" classes={{ tooltip: classes.tooltip }}>
                        <IconButton aria-label="Edit" className={classes.tableActionButton}>
                          <Edit className={`${classes.tableActionButtonIcon} ${classes.edit}`} />
                        </IconButton>
                      </Tooltip>
                      <Tooltip id="tooltip-top-start" title="Remove" placement="top" classes={{ tooltip: classes.tooltip }}>
                        <IconButton aria-label="Close" className={classes.tableActionButton}>
                          <Close className={`${classes.tableActionButtonIcon} ${classes.close}`} />
                        </IconButton>
                      </Tooltip>
                    </TableCell> */}
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </CardBody>
        </Card>
      </GridItem>
    </GridContainer>
  );
}
